import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "text-sm"
}
const _hoisted_2 = { class: "flex justify-between" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode("Cover Image")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("Social Image")
const _hoisted_5 = { class: "border-l-4" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "font-bold" }, "Scorecard Details", -1)
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = { class: "grid grid-cols-2 py-3 justify-evenly gap-x-2 px-7" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "mr-1 font-bold" }, "Add Match", -1)
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = { key: 1 }
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" SAVE ")
const _hoisted_13 = /*#__PURE__*/_createTextVNode(" Calculate Potential Score ")

import MatchEditor from '@/components/Scorecard/MatchEditor.vue';
import TablesEditor from '@/components/Scorecard/TablesEditor.vue';
import BriefcasesEditor from '@/components/Scorecard/BriefcasesEditor.vue';
import ScheduledEditor from '@/components/Scorecard/ScheduledEditor.vue';
import PotentialScore from '@/components/Scorecard/PotentialScore.vue';
import {
  computed,
  inject,
  onBeforeUpdate,
  onMounted,
  provide,
  Ref,
  ref,
} from 'vue';
import {
  Extra,
  Match,
  MatchParticipant,
  MatchStatus,
  MatchWinnerType,
  Scorecard,
} from '@/typings/scorecard';
import { useWrestlerStore } from '@/store/wrestlers';
import draggable from 'vuedraggable';
import { TEAM_NONE_ID, WRESTLER_NONE_ID } from '@/symbols/constants';
import SlideUpDown from 'vue3-slide-up-down';
import { useBrandStore } from '@/store/brands';
import TextField from '@/components/Inputs/TextField.vue';
import DateTime from '@/components/Inputs/DateTime.vue';
import Checkbox from '@/components/Inputs/Checkbox.vue';
import SearchDropdown from '@/components/Inputs/SearchDropdown.vue';
import { useValidation } from '@/composable/useValidation';
import { useRoute } from 'vue-router';
import { useScorecardStore } from '@/store/scorecards';
import Spinner from '@/components/UI/Spinner.vue';
import axios from 'axios';
import { AlertModal } from '@/typings/modal';
import { TemplateType } from '@/typings/template';

type MatchType = InstanceType<typeof MatchEditor>;

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const open = ref('');
provide('open', open);

const includeTables = ref(false);
const includeBriefcases = ref(false);

const scorecard = ref<Scorecard>({
  Tables: [] as string[],
  Matches: [
    {
      Title: '',
      Subtitle: '',
      ThirdTitle: '',
      Deleted: false,
      WinnerPointValue: 5,
      ExtraPointValue: 3,
      WinnerType: MatchWinnerType.Participating,
      SocialWinnerFormat: '',
      SocialMatchName: '',
      HasWinner: false,
      Participants: [] as MatchParticipant[],
      Teams: [] as MatchParticipant[],
      Questions: [] as Extra[],
    },
  ] as Match[],
  Brand: 'WWE',
  Briefcases: [] as string[],
  Unscheduleds: 0,
  Scheduled: [] as string[],
  TablePointValue: 0,
  AllUnscheduledBonusValue: 0,
  BriefcasePointValue: 0,
  UnscheduledPointValue: 0,
  Title: '',
  SocialHashTags: '',
} as Scorecard);

const showCover = ref(true);

const coverImageElement = ref<HTMLInputElement | null>(null);
const coverImage = ref<File>();
const socialImageElement = ref<HTMLInputElement | null>(null);
const socialImage = ref<File>();

function imageChanged(image: HTMLInputElement | null, selector: string) {
  if (image && image.files) {
    const uploaded = image.files[0];
    if (uploaded) {
      if (selector === '.cover') {
        coverImage.value = uploaded;
      } else {
        socialImage.value = uploaded;
      }
      const reader = new FileReader();
      reader.onloadend = () => {
        if (selector === '.cover') {
          coverImagePathValue.value = reader.result;
        } else {
          twitterImagePathValue.value = reader.result;
        }
      };
      reader.readAsDataURL(uploaded);
    }
  }
}

const matches = ref<MatchType[] | null>(null);

// Make sure to reset the refs before each update.
onBeforeUpdate(() => {
  matches.value = [];
});

function addMatch() {
  scorecard.value.Matches.push({
    Title: '',
    Subtitle: '',
    ThirdTitle: '',
    Status: MatchStatus.Open,
    Deleted: false,
    WinnerPointValue: 5,
    ExtraPointValue: 3,
    WinnerType: MatchWinnerType.Participating,
    SocialWinnerFormat: '{{WINNER}} wins by {{FALL}}',
    SocialMatchName: '',
    HasWinner: false,
    Participants: [] as MatchParticipant[],
    Teams: [] as MatchParticipant[],
    Questions: [] as Extra[],
    Order: 0,
  });
}

const wrestlerStore = useWrestlerStore();
const brandStore = useBrandStore();
const scorecardStore = useScorecardStore();

const route = useRoute();

const isLoading = ref(false);

async function initScorecard() {
  isLoading.value = true;
  if (route.params.slug) {
    await scorecardStore.getScorecardBySlug(route.params.slug.toString());
    if (scorecardStore.scorecard) {
      scorecard.value = scorecardStore.scorecard.event;
      includeTables.value = scorecard.value.Tables.length > 0;
      includeBriefcases.value = scorecard.value.Briefcases.length > 0;
    }
  } else {
    scorecard.value = {
      Tables: [] as string[],
      Matches: [
        {
          Title: '',
          Subtitle: '',
          ThirdTitle: '',
          Status: MatchStatus.Open,
          Deleted: false,
          WinnerPointValue: 5,
          ExtraPointValue: 3,
          WinnerType: MatchWinnerType.Participating,
          SocialWinnerFormat: '{{WINNER}} wins by {{FALL}}',
          SocialMatchName: '',
          HasWinner: false,
          Participants: [] as MatchParticipant[],
          Teams: [] as MatchParticipant[],
          Questions: [] as Extra[],
          Order: 0,
        },
      ] as Match[],
      Brand: 'WWE',
      Briefcases: [] as string[],
      Unscheduleds: 0,
      Scheduled: [] as string[],
      TablePointValue: 0,
      AllUnscheduledBonusValue: 0,
      BriefcasePointValue: 0,
      UnscheduledPointValue: 0,
      Title: '',
      SocialHashTags: '',
    } as Scorecard;
  }

  try {
    await axios.get(coverImagePath.value);
    coverImagePathValue.value = coverImagePath.value;
  } catch {
    coverImagePathValue.value =
      process.env.VUE_APP_IMAGE_PATH + 'event-default.png';
  }

  try {
    await axios.get(twitterImagePath.value);
    twitterImagePathValue.value = twitterImagePath.value;
  } catch (error) {
    console.log(error);
    twitterImagePathValue.value =
      process.env.VUE_APP_IMAGE_PATH + 'event-default.png';
  }
  isLoading.value = false;
}

onMounted(async () => {
  isLoading.value = true;
  wrestlerStore.getWrestlers();
  wrestlerStore.getTeams();
  brandStore.getBrands();
  initScorecard();
});

function matchRef(el: MatchType, index: number): void {
  if (matches.value) matches.value[index] = el;
  return;
}

function updateScheduled() {
  scorecard.value.Scheduled = [];
  for (const match of scorecard.value.Matches) {
    for (const participant of match.Participants) {
      scorecard.value.Scheduled.push(participant.SuperstarId);
    }
    for (const participant of match.Teams) {
      const team = wrestlerStore.teams.find(
        (t) => t.TeamId === participant.TeamId
      );
      if (team) {
        scorecard.value.Scheduled.push(...team.Members);
      }
    }
  }
  scorecard.value.Scheduled = scorecard.value.Scheduled.filter(
    (s) =>
      ![TEAM_NONE_ID.toString(), WRESTLER_NONE_ID.toString()].includes(
        s.toString()
      )
  );
}

const detailsVisible = ref(true);
const toggleDetailsVisible = () =>
  (detailsVisible.value = !detailsVisible.value);

const brands = computed(() =>
  brandStore.brands
    .map((b) => ({
      text: b.Name,
      value: b.Name,
    }))
    .sort()
);

function calculatePotentialScore() {
  let totalScore = 0;
  for (const match of scorecard.value.Matches) {
    totalScore += match.HasWinner ? match.WinnerPointValue : 0;
    totalScore += match.Questions.length * match.ExtraPointValue;
    totalScore +=
      match.Questions.filter((e) => e.Type === TemplateType.Number).length * 2;
  }

  totalScore += scorecard.value.Tables.length * scorecard.value.TablePointValue;
  totalScore +=
    scorecard.value.Briefcases.length * scorecard.value.BriefcasePointValue;
  totalScore +=
    scorecard.value.Unscheduleds * scorecard.value.UnscheduledPointValue;
  if (scorecard.value.Unscheduleds > 0) {
    totalScore += Number(scorecard.value.AllUnscheduledBonusValue);
  }
  scorecard.value.PossibleScore = totalScore;
}

function toggleImage(state: boolean) {
  showCover.value = state;
}

const { isPositiveNumber } = useValidation();

const isValid = computed(() => {
  if (isLoading.value) return false;
  const validBrand = !!brands.value.find(
    (b) => b.value === scorecard.value.Brand
  );
  const validName = scorecard.value.Title.length > 0;
  const validHashtags = scorecard.value.SocialHashTags.length > 0;
  const validUnscheduledCount =
    isPositiveNumber(scorecard.value.Unscheduleds) ||
    scorecard.value.Unscheduleds === 0;
  const validUnscheduledPoints = isPositiveNumber(
    scorecard.value.UnscheduledPointValue
  );
  const validUnscheduledBonus = isPositiveNumber(
    scorecard.value.AllUnscheduledBonusValue
  );
  const validUnscheduleds =
    scorecard.value.Unscheduleds === 0 ||
    (validUnscheduledCount && validUnscheduledPoints && validUnscheduledBonus);
  const validOpenDate = !!scorecard.value.OpensAt;
  const validLockDate = !!scorecard.value.LocksAt;
  const validDates =
    new Date(scorecard.value.OpensAt) < new Date(scorecard.value.LocksAt);

  const validTablesData =
    scorecard.value.Tables.length > 0 &&
    isPositiveNumber(scorecard.value.TablePointValue);
  let validTables = true;
  if (includeTables.value) {
    validTables = validTablesData;
  }

  const validBriefcasesData =
    scorecard.value.Briefcases.length > 0 &&
    isPositiveNumber(scorecard.value.BriefcasePointValue);
  let validBriefcases = true;
  if (includeBriefcases.value) {
    validBriefcases = validBriefcasesData;
  }

  const validImages =
    (scorecard.value.CoverImage && scorecard.value.TwitterImage) ||
    (!!coverImage.value && !!socialImage.value);

  let validMatches = true;
  if (matches.value && matches.value.length) {
    validMatches = matches.value.map((match) => match?.isValid).every((v) => v);
  }
  console.log({
    validBrand,
    validMatches,
    validName,
    validHashtags,
    validUnscheduleds,
    validOpenDate,
    validLockDate,
    validDates,
    validTables,
    validBriefcases,
    validImages,
    validUnscheduledCount,
    validUnscheduledPoints,
    validUnscheduledBonus,
  });

  return (
    validBrand &&
    validMatches &&
    validName &&
    validHashtags &&
    validUnscheduleds &&
    validOpenDate &&
    validLockDate &&
    validDates &&
    validTables &&
    validBriefcases &&
    validImages
  );
});

function removeMatch(index: number) {
  if (scorecard.value.Matches[index].MatchId) {
    scorecard.value.Matches[index].Deleted =
      !scorecard.value.Matches[index].Deleted;
  } else {
    scorecard.value.Matches.splice(index, 1);
  }
}

const alertModal = inject('alertModal') as Ref<AlertModal>;

async function onSave() {
  calculatePotentialScore();
  scorecard.value.Matches = scorecard.value.Matches.map((match, index) => {
    match.Order = index;
    match.Questions = match.Questions.map((question, i) => {
      question.Order = i;
      return question;
    });
    return match;
  });
  if (!isValid.value) {
    alertModal.value.show(
      'Scorecard not saved',
      'Something has been flagged as invalid. Please check open and lock dates, and all matches. A RED line will be displayed to the left of anything detected as invalid.'
    );
    return;
  }

  await scorecardStore.saveScorecard(scorecard.value, {
    cover: coverImage.value,
    twitter: socialImage.value,
  });
  alertModal.value.show('Scorecard saved', 'The scorecard has been saved!');
  initScorecard();
}

const coverImagePath = computed(
  () => process.env.VUE_APP_IMAGE_PATH + scorecard.value.CoverImage
);
const coverImagePathValue = ref(coverImagePath.value);
const twitterImagePath = computed(
  () => process.env.VUE_APP_IMAGE_PATH + scorecard.value.TwitterImage
);
const twitterImagePathValue = ref(twitterImagePath.value);

return (_ctx: any,_cache: any) => {
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!isLoading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_Button, {
              type: showCover.value ? 'primary' : 'secondary',
              class: "rounded-t rounded-b-none",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (toggleImage(true)))
            }, {
              default: _withCtx(() => [
                _hoisted_3
              ]),
              _: 1
            }, 8, ["type"]),
            _withDirectives(_createElementVNode("input", {
              ref: (_value, _refs) => {
                _refs['coverImageElement'] = _value
                coverImageElement.value = _value
              },
              type: "file",
              onChange: _cache[1] || (_cache[1] = ($event: any) => (imageChanged(coverImageElement.value, '.cover')))
            }, null, 544), [
              [_vShow, showCover.value]
            ]),
            _withDirectives(_createElementVNode("input", {
              ref: (_value, _refs) => {
                _refs['socialImageElement'] = _value
                socialImageElement.value = _value
              },
              type: "file",
              onChange: _cache[2] || (_cache[2] = ($event: any) => (imageChanged(socialImageElement.value, '.social')))
            }, null, 544), [
              [_vShow, !showCover.value]
            ]),
            _createVNode(_component_Button, {
              type: !showCover.value ? 'primary' : 'secondary',
              class: "rounded-t rounded-b-none",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (toggleImage(false)))
            }, {
              default: _withCtx(() => [
                _hoisted_4
              ]),
              _: 1
            }, 8, ["type"])
          ]),
          _withDirectives(_createElementVNode("div", null, [
            _createElementVNode("div", {
              class: "max-w-full bg-center bg-cover h-96 cover",
              style: _normalizeStyle({
          'background-color': 'var(--primary)',
          'background-image': `url(${coverImagePathValue.value})`,
        })
            }, null, 4)
          ], 512), [
            [_vShow, showCover.value]
          ]),
          _withDirectives(_createElementVNode("div", null, [
            _createElementVNode("div", {
              class: "max-w-full bg-center bg-cover h-96 social",
              style: _normalizeStyle({
          'background-color': 'var(--primary)',
          'background-image': `url(${twitterImagePathValue.value})`,
        })
            }, null, 4)
          ], 512), [
            [_vShow, !showCover.value]
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", null, [
              _createElementVNode("div", { class: "relative bg-secondary-light px-7" }, [
                _createElementVNode("div", {
                  class: "flex py-3 cursor-pointer select-none gap-x-1",
                  onClick: toggleDetailsVisible
                }, _hoisted_7)
              ]),
              _createVNode(_unref(SlideUpDown), {
                modelValue: detailsVisible.value,
                "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((detailsVisible).value = $event))
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_8, [
                    (_unref(brands).length > 0)
                      ? (_openBlock(), _createBlock(SearchDropdown, {
                          key: 0,
                          title: "Brand",
                          modelValue: scorecard.value.Brand,
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((scorecard.value.Brand) = $event)),
                          items: _unref(brands)
                        }, null, 8, ["modelValue", "items"]))
                      : _createCommentVNode("", true),
                    _createVNode(TextField, {
                      title: "Name",
                      modelValue: scorecard.value.Title,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((scorecard.value.Title) = $event)),
                      modelModifiers: { trim: true }
                    }, null, 8, ["modelValue"]),
                    _createVNode(TextField, {
                      title: "Hashtags",
                      modelValue: scorecard.value.SocialHashTags,
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((scorecard.value.SocialHashTags) = $event)),
                      modelModifiers: { trim: true }
                    }, null, 8, ["modelValue"]),
                    _createVNode(TextField, {
                      type: "number",
                      title: "# Unscheduleds",
                      modelValue: scorecard.value.Unscheduleds,
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((scorecard.value.Unscheduleds) = $event)),
                      modelModifiers: { number: true }
                    }, null, 8, ["modelValue"]),
                    _createVNode(TextField, {
                      type: "number",
                      title: "Unscheduled Points",
                      modelValue: scorecard.value.UnscheduledPointValue,
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((scorecard.value.UnscheduledPointValue) = $event)),
                      modelModifiers: { number: true }
                    }, null, 8, ["modelValue"]),
                    _createVNode(TextField, {
                      type: "number",
                      title: "All Unscheduled Bonus Points",
                      modelValue: scorecard.value.AllUnscheduledBonusValue,
                      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((scorecard.value.AllUnscheduledBonusValue) = $event)),
                      modelModifiers: { number: true }
                    }, null, 8, ["modelValue"]),
                    _createVNode(DateTime, {
                      modelValue: scorecard.value.OpensAt,
                      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((scorecard.value.OpensAt) = $event)),
                      title: "Opens At"
                    }, null, 8, ["modelValue"]),
                    _createVNode(DateTime, {
                      modelValue: scorecard.value.LocksAt,
                      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((scorecard.value.LocksAt) = $event)),
                      title: "Locks At"
                    }, null, 8, ["modelValue"]),
                    _createVNode(Checkbox, {
                      modelValue: includeTables.value,
                      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((includeTables).value = $event)),
                      title: "Tables?"
                    }, null, 8, ["modelValue"]),
                    _createVNode(Checkbox, {
                      modelValue: includeBriefcases.value,
                      "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((includeBriefcases).value = $event)),
                      title: "Briefcases?"
                    }, null, 8, ["modelValue"]),
                    _createVNode(Checkbox, {
                      modelValue: scorecard.value.IsChampionshipEligible,
                      "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((scorecard.value.IsChampionshipEligible) = $event)),
                      title: "Faction Champions?"
                    }, null, 8, ["modelValue"])
                  ])
                ]),
                _: 1
              }, 8, ["modelValue"])
            ])
          ]),
          _createVNode(_unref(draggable), {
            list: scorecard.value.Matches,
            handle: ".handle",
            tag: "div",
            "item-key": "MatchId"
          }, {
            item: _withCtx(({ element, index }) => [
              _createElementVNode("div", null, [
                _createVNode(MatchEditor, {
                  match: element,
                  ref: (el) => matchRef(el, index),
                  onParticipantsChanged: updateScheduled,
                  onRemove: ($event: any) => (removeMatch(index))
                }, null, 8, ["match", "onRemove"])
              ])
            ]),
            _: 1
          }, 8, ["list"]),
          _createElementVNode("div", { class: "bg-secondary-light px-7" }, [
            _createElementVNode("div", {
              class: "flex py-3 cursor-pointer select-none",
              onClick: addMatch
            }, _hoisted_10)
          ]),
          (includeTables.value)
            ? (_openBlock(), _createBlock(TablesEditor, {
                key: 0,
                tables: scorecard.value.Tables,
                "onUpdate:tables": _cache[16] || (_cache[16] = ($event: any) => ((scorecard.value.Tables) = $event)),
                tablePoints: scorecard.value.TablePointValue,
                "onUpdate:tablePoints": _cache[17] || (_cache[17] = ($event: any) => ((scorecard.value.TablePointValue) = $event))
              }, null, 8, ["tables", "tablePoints"]))
            : _createCommentVNode("", true),
          (includeBriefcases.value)
            ? (_openBlock(), _createBlock(BriefcasesEditor, {
                key: 1,
                briefcases: scorecard.value.Briefcases,
                "onUpdate:briefcases": _cache[18] || (_cache[18] = ($event: any) => ((scorecard.value.Briefcases) = $event)),
                "briefcase-points": scorecard.value.BriefcasePointValue,
                "onUpdate:briefcase-points": _cache[19] || (_cache[19] = ($event: any) => ((scorecard.value.BriefcasePointValue) = $event))
              }, null, 8, ["briefcases", "briefcase-points"]))
            : _createCommentVNode("", true),
          (scorecard.value.Unscheduleds > 0)
            ? (_openBlock(), _createBlock(ScheduledEditor, {
                key: 2,
                scheduleds: scorecard.value.Scheduled
              }, null, 8, ["scheduleds"]))
            : _createCommentVNode("", true),
          _createVNode(PotentialScore, {
            score: scorecard.value.PossibleScore
          }, null, 8, ["score"])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_11, [
          _createVNode(Spinner)
        ])),
    _createVNode(_component_Button, {
      onClick: onSave,
      class: "fixed text-white rounded top-20 right-20 bg-primary"
    }, {
      default: _withCtx(() => [
        _hoisted_12
      ]),
      _: 1
    }),
    _createVNode(_component_Button, {
      onClick: calculatePotentialScore,
      class: "fixed text-white rounded top-40 right-20 bg-primary"
    }, {
      default: _withCtx(() => [
        _hoisted_13
      ]),
      _: 1
    })
  ], 64))
}
}

})